// extracted by css-extract-rspack-plugin
export default {"root":"root-NjFCyF","svg":"svg-F9HmwZ","svgdark":"svgdark-BDlSRg"};